import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Radio, Space, Button, Row, Col, message, Spin, Modal } from 'antd';
import ImageUploadForm from './ImageUploadForm'; // Import the ImageUploadForm component
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import the Quill editor CSS
import TagsInput from '../Inputs/TagInput';
import Container from '../Container';
import FileUpload from '../Inputs/FIleUpload';
import { SaveOutlined } from '@ant-design/icons';
import SaveButton from '../Buttons/SaveButton';
import { createArticleService, updateArticleService } from '../../services/ArticleService';
import CustomLoadingModal from '../Modal/CustomLoadingModal';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;


const ArticleForm = ({ categories, subCategories, initialValues, onSubmit }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [articleImage, setArticleImage] = useState(initialValues?.ArticleImage || []);
  const [content, setContent] = useState(initialValues?.content || ''); // State for WYSIWYG content
  const [privacy, setPrivacy] = useState('PUBLIC'); // Default value is 'Public'
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [attachments, setAttachments] = useState(initialValues?.attachments || []);

  const [editingArticle, setEditingArticle] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState('Creation of article in progress...');

  const [attachmentsKey, setAttachmentsKey] = useState(0);  // Key to force re-render
  //state userId
  
  const [userId, setUserId] = useState(null); 
  const [roleType, setRoleType] = useState(null); // State for role type


  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues); // Set initial values when editing
      setContent(initialValues.content || ''); // Set initial WYSIWYG content
      
    }
    const id = localStorage.getItem('userId');
    const role = localStorage.getItem('roleType'); // Get the role type from local storage
    setRoleType(role); // Set the role type state
    setUserId(id) ; // Replace with your logic to get the user ID
  }, [initialValues, form]);

  // Handle image upload and update the articleImage state
  const handleImageUpload = (imageUrl) => {
    setArticleImage([{ url: imageUrl }]); // Assuming only one image is allowed
  };

  const handleArticleSubmit = async (values) => {

    setIsSubmitting(true); // Show the spinner
    setIsModalVisible(true); // Open the modal to show the process
    setModalMessage("Article creation in progress...");

    // getUserId function to get the user ID
   


    try {
      const formattedAttachments = attachments.map((attachment) => ({
        label: attachment.label,
        url: attachment.url,
      }));
      if (editingArticle) {
        await updateArticleService(editingArticle.id, values);

        message.success('Article updated successfully');
      } else {
        console.log("article values: ",values);
        const articleData = {
          title: values.title,
          url: values.title,
          content: values.content,
          visibility: values.visibility,
          status: roleType=="ADMIN"?"APPROVED":"DRAFT",
          tags: values.tags.join(', '),
          User:{
            connect: { id: parseInt(userId) }
           }, 
          Category: {
            connect: {
              id: parseInt(values.categoryId, 10), // Ensure it's an integer
            },
          },
          SubCategory: {
            connect: {
              id: parseInt(values.subCategoryId, 10), // Ensure it's an integer
            },
          },
          coverUrl:
            values.ArticleImage[0]?.url || '',
          ArticleAttachment: {
            create: formattedAttachments, // Pass formatted attachments
          },

        };
        await createArticleService(articleData);
        setModalMessage('Article created successfully');
        // Simulate an async operation like creating or updating an article
       
        await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulating 3 seconds delay
       
        setIsSubmitting(false);
        setIsModalVisible(false);
        setAttachmentsKey(attachmentsKey + 1);
        form.resetFields();
        setArticleImage([]); // Reset image preview
        setContent(''); // Reset content editor state
        //setTags([]); // Reset tags input
        setAttachments([]); // Reset attachments if needed
        setPrivacy('PUBLIC');
        message.success('Article created successfully');
        await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulating 3 seconds delay
        navigate('/admin/articles'); // Redirect to the articles page after creation
        

        
      }
      //setIsModalVisible(false);
      // fetchArticles();
    } catch (error) {
      setModalMessage('Error while creating article');
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulating 3 seconds delay
      setIsModalVisible(false);
      setIsSubmitting(false);
      message.error('Error while creating/updating article');
    }
  };


  // Handle form submission, including the uploaded image and content
  const handleSubmit = (values) => {
    const articleData = { ...values, content, ArticleImage: articleImage }; // Include WYSIWYG content
    handleArticleSubmit(articleData); // Pass form data to the parent component (e.g., ArticleTable)
  };

  const handleTagsChange = (tags) => {
    form.setFieldsValue({ tags }); // Set the tags field in the form
  };

  // Handle category change and filter subcategories based on the selected category
  const handleCategoryChange = (categoryId) => {
    const filtered = subCategories.filter((subCategory) => subCategory.parentId == categoryId);
    console.log(subCategories);
    setFilteredSubCategories(filtered);
    //console.log(filtered);
    //  console.log(subCategories);
    form.setFieldsValue({ subCategoryId: undefined }); // Reset subcategory when category changes
  };
  const handleAttachmentsChange = (newAttachments) => {
    setAttachments(newAttachments);
  };
  const onPrivacyChange = (e) => {
    setPrivacy(e.target.value);
  };

  return (
    <Container >
      {/* Image Upload Field */}

      <Form form={form} onFinish={handleSubmit} labelCol={{ span: 24 }} initialValues={initialValues}>
        <Form.Item label="" style={{ marginTop: '50px' }}>
          <ImageUploadForm onImageUpload={handleImageUpload} />
          {articleImage.length > 0 && (
            <img src={articleImage[0].url} alt="Uploaded" style={{ maxWidth: '100%', marginTop: 10 }} />
          )}
        </Form.Item>
        <Form.Item name="title" label="Title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        {/* WYSIWYG Editor for Content */}
        <Form.Item label="Content" rules={[{ required: true }]}>
          <ReactQuill theme="snow" value={content} onChange={setContent} />
        </Form.Item>

        {/* Category and Subcategory on the same row */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="categoryId" label="Category" rules={[{ required: true }]}>
              <Select placeholder="Select a category" onChange={handleCategoryChange}>
                {categories.map((category) => (
                  <Option key={category.id} value={category.id}>
                    {category.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="subCategoryId" label="Sub-category" rules={[{ required: true }]}>
              <Select placeholder="Select a subcategory">
                {filteredSubCategories.map((subCategory) => (
                  <Option key={subCategory.id} value={subCategory.id}>
                    {subCategory.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* Privacy Options and Tags Input on the same row */}
        <Row gutter={16}>
          <Col span={12}>
            {/* Privacy Options (Radio buttons in a row) */}
            <Form.Item name="visibility" label="Visibility" rules={[{ required: true }]}>
              <Radio.Group onChange={onPrivacyChange} value={privacy}>
                <Radio value="PUBLIC">Public</Radio>
                <Radio value="PRIVATE">Private</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col span={12}>
            {/* Tags Input */}
            <Form.Item label="Tags" name="tags" rules={[{ required: true }]}>
              <TagsInput onChange={handleTagsChange} />
            </Form.Item>
          </Col>
        </Row>


        <Form.Item label="">
          <FileUpload key={attachmentsKey} onAttachmentsChange={handleAttachmentsChange} />
        </Form.Item>

        {/* Submit Button */}
        <Form.Item>
          <Button
            type="primary"
            htmlType='submit'
            size="large" // Large size for better visibility
            icon={<SaveOutlined />} // Simple icon
            style={{
              background: 'black',
              borderRadius: '12px', // Subtle rounded corners
              padding: '12px 24px', // Comfortable padding
              fontSize: '16px', // Larger font for readability
            }}

          >
            Save
          </Button>
        </Form.Item>
      </Form>
      {/* Loading Modal */}
      <CustomLoadingModal
        visible={isModalVisible}
        loading={isSubmitting}
        message={modalMessage}
      />
    </Container>
  );
};

export default ArticleForm;
